const getAxiosErrorObject = (error: any) => {
  const errObj = error ? JSON.parse(JSON.stringify(error)) : {};
  return errObj
};

async function handleApiError(error: any) {
  const errResponse = getAxiosErrorObject(error);
  return errResponse;
}

export { handleApiError, getAxiosErrorObject };
